module.exports = __webpack_public_path__ + "img/logo-1.daa4f797.svg";